import { paramKeys } from '@constants/key';
import CountDown from '@fragments/CountDown';
import { useInterviewerCameraOn } from '@hooks/device/useInterviewerCameraOn';
import { useAttendee } from '@hooks/utils/useAttendee';
import InterviewTime from '@pages/Interviewer/Room/InterviewTime';
import { interviewTime } from '@stores/atoms/time';
import { externalApiUrl } from '@stores/atoms/url';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useEffect, type FC } from 'react';
import { useSearchParams } from 'react-router';
import Header from './Header';
import Video from './Video';
import { Container, FloatingArea, HelpButton, HelpIcon } from './style';

const InterviewerRoomPage: FC = () => {
  const [searchParams] = useSearchParams();
  const resetInterviewTime = useResetAtom(interviewTime);
  const apiUrl = useAtomValue(externalApiUrl);

  useAttendee();
  useInterviewerCameraOn(
    searchParams.get(paramKeys.camera)?.toString() === 'on',
  );

  useEffect(() => {
    return () => {
      resetInterviewTime();
    };
  }, []);

  const handleHelp = () => {
    window.open(
      `${apiUrl}/videoGuide`,
      '도움말',
      'toolbar=no,scrollbars=no,resizable=no,top=50,left=100,width=820,height=960',
    );
  };

  return (
    <Container>
      <Header />
      <Video />
      <FloatingArea>
        <InterviewTime />
        <HelpButton onClick={handleHelp}>
          <HelpIcon />
          도움말
        </HelpButton>
      </FloatingArea>
      <CountDown title='곧 화상면접이 시작됩니다' />
    </Container>
  );
};

export default InterviewerRoomPage;
